import { colors } from "constants/colors";
import React from "react";

import { SpeachBalloon, SpeachBalloonProps } from "../SpeachBalloon";
import { WidthLinkText } from "components/parts/WithLinktext";
import {
  StyledMentionedListContainer,
  StyledMentionedSpan,
  StyledWithMentionContainer,
} from "components/report/Mention/styled";

export type TextSpeachBalloonProps = {
  text: string;
  mentionedList?: { id: string; name: string }[];
  isMyChat?: boolean;
} & SpeachBalloonProps;

export const TextSpeachBalloon: React.FC<TextSpeachBalloonProps> = ({
  text,
  mentionedList,
  border,
  isMyChat,
}) => {
  return (
    <SpeachBalloon
      background={
        isMyChat ? colors.moderatorTextBalloonBackGround : colors.white
      }
      border={border}
      borderRadius={"10px"}
    >
      <StyledWithMentionContainer>
        {mentionedList?.length !== 0 && (
          <StyledMentionedListContainer>
            {mentionedList?.map((mentioned) => (
              <StyledMentionedSpan key={mentioned.id}>
                @{mentioned.name}
              </StyledMentionedSpan>
            ))}
          </StyledMentionedListContainer>
        )}
        <WidthLinkText text={text} textColor={colors.text} fontSize="medium" />
      </StyledWithMentionContainer>
    </SpeachBalloon>
  );
};
